import { HeadingText } from '@paypalcorp/pp-react'
import React, { useContext } from 'react'
import { MessageFormat } from '@paypalcorp/worldready'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'

function Header() {
  const worldReady = useContext(WorldReadyContext)
  const logInMessage = new MessageFormat(worldReady, {
    id: `authLogin.loginWith`,
  }).format()
  return (
    <div className="aa_header">
      <HeadingText size="sm" className="aa_headingTextHeader">
        {logInMessage}
      </HeadingText>
      <img
        src="https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-color.svg"
        style={{ width: '120px', paddingLeft: '10px' }}
      />
    </div>
  )
}

export default Header
